import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Contact } from 'src/app/shared/models/clients/contact';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { cities } from 'src/app/shared/models/cities';
import { countries } from 'src/app/shared/models/countries';

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss']
})
export class ContactModalComponent implements OnInit {

  public contact: Contact;
  public cities = cities;
  public countries = countries;

  @ViewChild('contactModal') contactModal;
  @Output() submit: EventEmitter<Contact> = new EventEmitter<Contact>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: ClientsApiService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(contact: Contact) {
    this.contact = Object.assign(new Contact(), contact);
    this.modalRef = this.modalService.open(this.contactModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.contact.id) {
      this.spinner.show();
      this.api.updateClientContact(this.contact.clientId, this.contact).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createClientContact(this.contact.clientId, this.contact).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

  searchFn() {
    return true;
  }


}
